export default {
  currentUser: {
    ID: '',
    FullName: '',
    Email: '',
    Gender: '',
    DateOfBbirth: '',
    AddressList: [],
    IdentityCard: '',
    Phone: '',
    OtherPhoneNumber: '',
    BusinessLicense: '',
    IsCompany: false,
    IsMainAccount: false,
    IsHavePayment: false,
    IsHinoAccount: false,
    IsViaEmail: 0
  },
  username: ''
}
